export class MsgAccueil {
            
    public message:string
    public usePlanif:boolean
    public startDay:number
    public startUtcTime:string
    public endDay:number
    public endUtcTime:string

    constructor({message="", usePlanif=false,startDay=0,startUtcTime="00:00",endDay=0,endUtcTime="00:00"} = {}) {                                
        this.message = message
        this.usePlanif = usePlanif
        this.startDay = startDay
        this.startUtcTime = startUtcTime
        this.endDay = endDay
        this.endUtcTime = endUtcTime
    }    

    static createMsgAccueil(datas:string) {      
        let data = {}
        try{
            if(!datas) datas = ""
            data = JSON.parse(datas)
        }
        catch(e) {
            data = {message:datas}
        }
        return new MsgAccueil(data)
    }

    static isVisible(msg:MsgAccueil){
        if(!msg.usePlanif) return true
        
        let visible = true                
        const now = new Date()
        const nowDay = now.getUTCDay()
        const nowHour = now.getUTCHours()
        const nowMinutes = now.getUTCMinutes()
        const startPart = msg.startUtcTime.split(':')
        //@ts-ignore
        const startHour =  Number.parseInt(startPart?.at(0) ?? "0")
        //@ts-ignore
        const startMin =  Number.parseInt(startPart?.at(1) ?? "0")
        const endPart = msg.endUtcTime.split(':')
        //@ts-ignore
        const endHour =  Number.parseInt(endPart?.at(0) ?? "0")
        //@ts-ignore
        const endMin =  Number.parseInt(endPart?.at(1) ?? "0")

        return (nowDay > msg.startDay ||  (nowDay == msg.startDay && (nowHour > startHour || (nowHour == startHour && nowMinutes >= startMin)))) &&
               (nowDay < msg.endDay ||  (nowDay == msg.endDay && (nowHour < endHour || (nowHour == endHour && nowMinutes <= endMin))))

    }

}
